import { render } from "./ReaderImport.vue?vue&type=template&id=65e9ced8&scoped=true"
import script from "./ReaderImport.vue?vue&type=script&lang=js"
export * from "./ReaderImport.vue?vue&type=script&lang=js"

import "./ReaderImport.vue?vue&type=style&index=0&id=65e9ced8&lang=scss&scoped=true"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e9ced8"]])

export default __exports__